export const KeyId = {
  'customer-enquiry': { id: 'CustomerId' },
  'inventory-enquiry': { id: 'ProductId' },
  'pick-slips': { id: 'DespatchId' },
};
